import React, { useEffect, useState } from 'react'
import Header from "../template/Header";
import Menu from "../template/Menu";
import Footer from "../template/Footer";
import Loading from "../components/loading/Loading";
import { Button, Col, Row } from "react-bootstrap";
import TableData from "../components/table/TableData"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight,faMagnifyingGlass,faPlus } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { alertMinus } from "../components/alertValid/AlertValid.js"
import {
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
} from "../components/ThemeConfig/btnConfig";
import { useButtonDynamicStyles } from "../components/useDynamic/Button_DynamicStyle";
import formatDatetime from "../utils/formatDateTime.js";
import { getBidding, deleteBidding } from "../api/bidding_api.js"
import { formatDateYYYYMMDD } from "../utils/formatDate.js";

function BiddingInformation() {
    useButtonDynamicStyles(
        textSearchBtn,
        textResetBtn,
        textCreateBtn,
        colorSearchBtn,
        colorResetBtn,
        colorCreateBtn,
        iconSearchBtn,
        iconResetBtn,
        iconCreateBtn,
        hoverSearchBtn,
        hoverResetBtn,
        hoverCreateBtn,
        textSaveBtn,
        textCancleBtn,
        colorSaveBtn,
        colorCancleBtn,
        hoverSaveBtn,
        hoverCancleBtn,
        colorEditBtns,
        hoverEditBtns
    );
    
    const [isLoading, setLoading] = useState(false);
    const [inputDateStart, setInputDateStart] = useState("");
    const [inputDateEnd, setInputDateEnd] = useState("");

    const [dataSearch, setDataSearchJobApp] = useState({
        name: "",
        startDate: "",
        endDate: "",
    });

    const [inputForm, setInputForm] = useState({
        nationality: 0,
        position: 0,
    });

    function setinput(inputname, value) {
        setInputForm((prev) => {
            return {
                ...prev,
                [inputname]: value,
            };
        });
    }

    const navigate = useNavigate();
    const navigateToAddPage = () => {
        navigate("/a&eInfoBiddingInfo");
    };

    const [dataTable, setDatatable] = useState([]);

    const dataHeader = [
        { label: "No",column:'no' , style: { width: "10%", borderLeft: "1px solid #000",borderTopLeftRadius: "10px",borderTopRightRadius: "0px",borderBottomLeftRadius: "10px"
        ,borderBottomRightRadius: "0px",position:'relative' },status: true
        },
        { label: "Title",column:'name_en' , style: { width: "25%",borderRadius: "0px",position:'relative' }, status: true },
        { label: "Update",column:'updated_at', style: { width: "20%",borderRadius: "0px",position:'relative' }, status: true },
        { label: "Status",column:'active' , style: { width: "20%",borderRadius: "0px",position:'relative' }, status: true },
        { label: "Action",column:'action', style: { width: "15%",borderRight: "1px solid #000",borderTopRightRadius: "10px",borderTopLeftRadius: "0px",borderBottomRightRadius: "10px",borderBottomLeftRadius: "0px"
        ,position:'relative' } }
    ];
    const [tableParam, setTableParam] = useState({
        sorting:{ column: "", order: "" },
        pageNumber:1,
        dataPerPage:10,
    }); //กำหนด column เริ่มต้นในการ sort
    const [totalNumber, setTotalNumber] = useState(0)
    useEffect(()=>{
        getTableData()
    },[tableParam])
    // const seachTable = (column,value) => {
    //     setTableParam((prevTableParam) => ({
    //         ...prevTableParam,
    //         searching: {...prevTableParam.searching,[column]:value},
    //       }));
    //   //newSorting example 
    // };
    const sortTable = (newSorting) => {
        setTableParam((prevTableParam) => ({
            ...prevTableParam,
            sorting: newSorting,
        }));   
    };    
    const changePage = (pageNumber) => {
        setTableParam((prevTableParam) => ({
            ...prevTableParam,
            pageNumber: pageNumber,
        }));   
      //newSorting example 1
    };
    const changeDataPerPage = (dataPerPage) => {
        setTableParam((prevTableParam) => ({
            ...prevTableParam,
            dataPerPage: dataPerPage,
        }));   
      //newSorting example 10
    };

    async function getTableData() {
        try {
            await setLoading(true);
            const param = {
                type: 'info',
                name: dataSearch.name,
                sort_by:tableParam.sorting.column=='no'?'_id':tableParam.sorting.column,
                order_by:tableParam.sorting.order,
                page_number:tableParam.pageNumber,
                data_per_page:tableParam.dataPerPage,
                start_date:inputDateStart?new Date(formatDateYYYYMMDD(inputDateStart)):'',
                end_date:inputDateEnd?new Date(formatDateYYYYMMDD(inputDateEnd)):'',
            }
            let response = await getBidding(param);

            let tmpDataTable = [];
            setTotalNumber(response.data.meta.total)
            for (let i = 0; i < response.data.data.length; i++) {
                const ascendingNo = { data: (i + 1)+((tableParam.pageNumber-1)*tableParam.dataPerPage) };
                const descendingNo = { data: response.data.meta.total - ((tableParam.pageNumber - 1) * tableParam.dataPerPage) - i };
                let model = {
                    no: tableParam.sorting.order == 'desc'&& tableParam.sorting.column=='no' ?
                            descendingNo:ascendingNo,
                    user_id: { data: response.data.data[i]._id
                        ,isHide: true,},
                    name: { data: response.data.data[i].name_en },
                    updated_at: {
                        data: response.data.data[i].update_by+ ' | ' + formatDatetime(response.data.data[i].updated_at),
                    },
                    active: {
                        data: response.data.data[i].active === 1 ? "Active" : "Inactive",
                        style: {
                            color: response.data.data[i].active === 1 ? "#87BD66" : "#D95350",
                        },
                    },
                    action: {
                        view: false,
                        create: false,
                        delete: true,
                        update: false,
                        edit: true,
                    },
                };
                tmpDataTable.push(model);
            }
            setDatatable(tmpDataTable)
        } catch (error) {
            console.log('err getTableData',error)
        }
        await setLoading(false);
    }

    const handleSearchBtn = async () => {
        getTableData();
    };

  return (
    <>
        {isLoading ? <Loading /> : ""}
        <Header parentmenu={"OPEN TENDERING PROJECT"} />
        <Menu
            parentmenu={"infoTendering"}
            activemenu={"infoBiddingInformation"}
        />
        <div className="content-wrapper">
            <div className="container-fluid pdb-page">
                <div className="box-white">
                    <Row>
                        <Col xs={12}>
                            <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                                <img src="assets/icons/ic-open.png" className="ic-user01 me-2" alt="" />
                                OPEN TENDERING PROJECT<FontAwesomeIcon icon={faChevronRight} className="h-8 p-2" /> BIDDING INFORMATION
                            </font>
                        </Col>
                    </Row>
                    <div className='mx-5'>
                        <Row>
                            <Col xs={12} className='mt-3'>
                                <font className="font-size08 colorBlack01 fontBold d-flex align-items-center">
                                    Search
                                </font>
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col xs={4} className="d-flex align-items-center pe-0">
                                <Row className="d-flex align-items-center w-100">
                                    <Col xs={3} className='pe-0'>
                                        <label className="fontLight font-size01 colorBlack01 mb-0">
                                        Name Bidding
                                        </label>
                                    </Col>
                                    <Col xs={9} className='pe-0'>
                                        <input
                                            type="text"
                                            className="inp01 fontLight font-size03"
                                            id="name"
                                            placeholder="name"
                                            value={dataSearch.name}
                                            onChange={(event) =>
                                                setDataSearchJobApp({
                                                ...dataSearch,
                                                name: event.target.value,
                                                })
                                            }
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            {/* <Col xs={3} className="d-flex align-items-center pe-0">
                                <Row className="d-flex align-items-center w-100">
                                    <Col xs={3} className='pe-0'>
                                        <label className="fontLight font-size01 colorBlack01 mb-0">
                                        Start Date
                                        </label>
                                    </Col>
                                    <Col xs={9} className='pe-0'>
                                        <Calendarpicker
                                            dataDate={null}
                                            setDatePicker={setinput}
                                            inputname={"inp2"}
                                            ChangesetValueDate={ChangesetValueDateStart}
                                            inputDate={inputDateStart}
                                        />
                                    </Col>
                                </Row>
                            </Col> */}
                            {/* <Col xs={3} className="d-flex align-items-center pe-0">
                                <Row className="d-flex align-items-center w-100">
                                    <Col xs={3} className='pe-0'>
                                        <label className="fontLight font-size01 colorBlack01 mb-0">
                                        End Date
                                        </label>
                                    </Col>
                                    <Col xs={9} className='pe-0'>
                                        <Calendarpicker
                                            dataDate={null}
                                            setDatePicker={setinput}
                                            inputname={"inp3"}
                                            ChangesetValueDate={ChangesetValueDateEnd}
                                            inputDate={inputDateEnd}
                                        />
                                    </Col>
                                </Row>
                            </Col> */}
                            <Col xs={2} className="d-flex justify-content-start">
                                <Button className="btn-search"
                                    onClick={(e) => {
                                        handleSearchBtn();
                                    }}
                                >
                                        
                                <FontAwesomeIcon icon={faMagnifyingGlass} className="colorBlack01 me-2"/>
                                    Search
                                </Button>
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col xs={3}>
                                <Button className="btn-create" onClick={() => navigateToAddPage()}>
                                    <FontAwesomeIcon icon={faPlus} className="colorWhite me-2"/>
                                    Add
                                </Button>
                            </Col>
                        </Row>
                        <Row>
                            <TableData
                                dataHeader={dataHeader}
                                editUrl={"/a&eInfoBiddingInfo?id="}
                                dataTable={dataTable}
                                idName={"user_id"}
                                removeData={(id) => alertMinus(id, deleteBidding)}
                                tableParam={tableParam}
                                sortTable={sortTable}
                                changePage={changePage}
                                changeDataPerPage={changeDataPerPage}
                                totalNumber={totalNumber}
                                tablePermission={{
                                    view: false,
                                    create: false,
                                    delete: true,
                                    update: false,
                                    edit: true,
                                }}
                            />
                        </Row>
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
    </>
  )
}

export default BiddingInformation;